/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Explorer_Nav_Load_Tasks_Failed_ToastInputs */



/**
* | output |
* | --- |
* | "Failed to load assigned tasks" |
*
* @param {Explorer_Nav_Load_Tasks_Failed_ToastInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const explorer_nav_load_tasks_failed_toast = /** @type {((inputs?: Explorer_Nav_Load_Tasks_Failed_ToastInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Explorer_Nav_Load_Tasks_Failed_ToastInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Echec du chargement des taches assignees")
	if (locale === "de") return /** @type {LocalizedString} */ ("Zugewiesene Aufgaben konnten nicht geladen werden.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Impossibile caricare le attivita assegnate")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Не удалось загрузить назначенные задачи.")
	if (locale === "es") return /** @type {LocalizedString} */ ("No se pudieron cargar las tareas asignadas")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("加载分配的任务失败")
	if (locale === "ja") return /** @type {LocalizedString} */ ("割り当てられたタスクの読み込みに失敗しました")
	if (locale === "hi") return /** @type {LocalizedString} */ ("सौंपे गए कार्य लोड करने में विफल")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Falha ao carregar tarefas atribuidas")
	return /** @type {LocalizedString} */ ("Failed to load assigned tasks")
});